/**
 * Hourly rate for DO instabook candidate detail (CustomOfferDetailsPage).
 * Prefer rate from available-hygienists API / navigation state (T2-6432).
 */
export function resolveInstabookHourlyRate(
  instabookHourlyRate?: number | string | null,
  hygienist?: {
    hourlyRate?: number | string | null;
    GlobalSettings?: { hourlyRate?: number | string | null };
  } | null,
): string {
  const candidates = [
    instabookHourlyRate,
    hygienist?.hourlyRate,
    hygienist?.GlobalSettings?.hourlyRate,
  ];

  for (const raw of candidates) {
    if (raw === null || raw === undefined || raw === '') continue;
    const n = Number(raw);
    if (Number.isFinite(n) && n > 0) {
      return `$${n}/hr`;
    }
  }

  return 'N/A';
}

export interface ShiftLocationDisplay {
  address?: string;
  city?: string;
  province?: string;
}

export function formatShiftLocationLines(location?: ShiftLocationDisplay | null): {
  line1: string;
  line2: string;
} {
  if (!location?.address && !location?.city) {
    return { line1: '', line2: '' };
  }

  const line1 = location.address ? `${location.address},` : '';
  const line2 = [location.city, location.province].filter(Boolean).join(', ');

  return { line1, line2 };
}
